module.exports = __webpack_public_path__ + "static/fonts/Mont-HeavyItalic.2e4c253.ttf";